import { Box, CircularProgress } from "@mui/material";

export const CenteredCircularLoading = ({ size = 50 }: { size?: number }) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
};
